export default "__VITE_ASSET__BUd2Vz5P__"